module.exports = __webpack_public_path__ + "static/media/key-1.96e63ca9.glb";